let el
let closeBtn
let copyBtn
let copiedAlert

let copyText
let copyDom

const mediaQuery = '(max-width: 63.999em)'

let resizing

export function AlertBanner() {
    el = document.querySelector('.js-alert-banner')
    if (!el) {
        return
    }

    document.body.style.setProperty('--alert-height', el.offsetHeight + 'px')

    closeBtn = el.querySelector('.js-alert-banner-close')
    closeBtn.addEventListener('click', closeAlert)

    copyBtn = el.querySelector('.js-alert-banner-copy-btn')

    if (!copyBtn) {
        return
    }

    copyDom = document.createElement('textarea')
    copyDom.classList.add('u-visually-hidden')
    copyDom.setAttribute('aria-hidden', 'true')
    copyDom.readOnly = true
    el.appendChild(copyDom)

    copyText = copyBtn.dataset.copy
    copyDom.value = copyText
    copiedAlert = el.querySelector('.js-alert-banner-copied-alert')
    copyBtn.addEventListener('click', copyToClip)
    el.addEventListener('click', () => {
        if (window.matchMedia(mediaQuery).matches) {
            copyToClip()
        }
    })

    window.addEventListener('resize', () => {
        if (resizing) {
            return
        }
        resizing = true
        requestAnimationFrame(() => {
            el.style.setProperty('--height', el.offsetHeight + 'px')
            resizing = false
        })
    })
}

function closeAlert() {
    el.classList.add('hidden')
}

function copyToClip() {
    copyDom.select()
    document.execCommand('copy')
    showCopyAlert()
}

function showCopyAlert() {
    copiedAlert.classList.remove('trigger')

    requestAnimationFrame(() => {
        copiedAlert.classList.add('trigger')
    })
}
